import {
  Autocomplete as MantineAutocomplete,
  type AutocompleteProps,
} from "@mantine/core";
import { useMemo } from "react";
import {
  normalizeAutocompleteData,
  normalizeSelectData,
} from "src/utils/mantineComboboxData";

export type { AutocompleteProps };

function Autocomplete({ data, ...props }: AutocompleteProps) {
  const normalizedData = useMemo(() => {
    if (!data?.length) return [];
    const first = data[0];
    if (typeof first === "object" && first !== null && "label" in first) {
      return normalizeSelectData(data);
    }
    return normalizeAutocompleteData(data);
  }, [data]);

  return <MantineAutocomplete {...props} data={normalizedData} />;
}

export default Autocomplete;
